import {
  areDirectoriesDownloaded,
  getAllDirectoryModels,
  getDirectoriesByQuery,
  getDirectoryBreadcrumbs,
} from 'serviceWorker/broadcasts/directories';
import {
  directoriesSync,
  handleCreateDirectoriesBatch,
  handleCreateDirectory,
  handleEditDirectory,
} from 'serviceWorker/services/directories';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { directoryContract } from 'shared/domain/directory/directoryContract';
import { runWhenRequestsAllowed, syncWhenRequestsAllowed } from './runWhenRequestsAllowed';

/** Answers directory requests of the page. */
export function serveDirectoryRequests(): ChannelUnsubscribe {
  return channelServer.handle(directoryContract, {
    getChildren: ({ parentId }) => getDirectoriesByQuery(parentId),
    getAll: async () => {
      if (!(await areDirectoriesDownloaded())) {
        syncWhenRequestsAllowed(directoriesSync.sync);
      }
      return getAllDirectoryModels();
    },
    getBreadcrumbs: ({ directoryId }) => getDirectoryBreadcrumbs(directoryId),
    create: handleCreateDirectory,
    // Answered at once; the outcome, also a failure, follows as `directoriesBatchCreated` with the `uniqueId`.
    createBatch: ({ directories, uniqueId }) => void handleCreateDirectoriesBatch({ directories, uniqueId }),
    edit: handleEditDirectory,
    sync: () => runWhenRequestsAllowed(directoriesSync.sync),
  });
}
